import React from 'react'
import styled from 'styled-components'
import Sector from '../sector'
import White from '../white'

function slugify(str) {
  str = str.replace(/^\s+|\s+$/g, '');
  str = str.toLowerCase();
  var stars = '';
  str = stars + str;
  var from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;'";
  var to = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa-------";
  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }
  str = str.replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
  return str;
}

const SectorGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 60px;
  width: calc(100vw - 64px);
  max-width: ${props => props.fullwidth ? '100vw' : '1200px'};
  margin-left: auto;
  margin-right: auto;
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 40px;
    width: calc(100vw - 2rem);
  }
`

const Sectors = ({sectors}) => {

  return (
    <White>
      <SectorGrid>
        {sectors.map((sector, index) => {
          const cn = slugify(sector.heading);
          return (
            <Sector className={cn} key={index} index={index} module={sector} />
          )
        })}
      </SectorGrid>
    </White>
  )
}

export default Sectors
